import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const AudienceTargetingIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "AudienceTargeting",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M27.46 13.07c-1.08-4.21-4.39-7.5-8.61-8.55a3 3 0 0 0-3.48-2.44 3 3 0 0 0-2.44 2.44 11.89 11.89 0 0 0-8.45 8.56 2.915 2.915 0 0 0-2.44 3.32 2.92 2.92 0 0 0 2.44 2.44c1.04 4.21 4.28 7.52 8.47 8.64a3 3 0 0 0 3.48 2.44 3 3 0 0 0 2.44-2.44c4.24-1.07 7.55-4.37 8.62-8.61 1.59-.22 2.71-1.7 2.48-3.29a2.906 2.906 0 0 0-2.48-2.48zM18.5 25.66a3.03 3.03 0 0 0-2-1.45V21.5c0-.16-.14-.29-.31-.29h-.72a.29.29 0 0 0-.29.29v2.73c-.8.18-1.48.7-1.88 1.42a9.92 9.92 0 0 1-6.95-7.04 2.95 2.95 0 0 0 1.49-1.74h2.66c.17 0 .31-.14.31-.31v-.72c0-.16-.14-.29-.31-.29H7.95c-.15-.93-.73-1.72-1.57-2.15a9.95 9.95 0 0 1 6.92-6.96c.41.7 1.09 1.21 1.89 1.39v2.99c0 .16.13.3.29.31h.72c.17 0 .31-.14.31-.31V7.85c.84-.16 1.58-.67 2.01-1.41 3.43.91 6.12 3.57 7.06 6.99-.8.41-1.36 1.17-1.54 2.05h-2.87c-.16 0-.3.13-.31.29v.72c0 .17.14.31.31.31h2.97c.24.75.77 1.37 1.47 1.72a9.95 9.95 0 0 1-7.11 7.13Z"
      })
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("path", {
        d: "M29.43 30.57c-.29 0-.58-.11-.81-.33l-5.71-5.71a1.14 1.14 0 0 1 0-1.62 1.14 1.14 0 0 1 1.62 0l5.71 5.71a1.14 1.14 0 0 1-.81 1.95"
      }), /*#__PURE__*/_jsx("path", {
        d: "M14.57 28.28C7.01 28.28.86 22.13.86 14.57S7.01.86 14.57.86s13.71 6.15 13.71 13.71-6.15 13.71-13.71 13.71m0-25.14c-6.3 0-11.43 5.13-11.43 11.43S8.27 26 14.57 26 26 20.87 26 14.57 20.87 3.14 14.57 3.14"
      }), /*#__PURE__*/_jsx("path", {
        d: "M29.43 30.57c-.29 0-.58-.11-.81-.33l-5.97-5.97a1.14 1.14 0 0 1 0-1.62 1.14 1.14 0 0 1 1.62 0l5.97 5.97a1.14 1.14 0 0 1-.81 1.95"
      }), /*#__PURE__*/_jsx("path", {
        d: "M14.57 28.28C7.01 28.28.86 22.13.86 14.57S7.01.86 14.57.86s13.71 6.15 13.71 13.71-6.15 13.71-13.71 13.71m0-25.14c-6.3 0-11.43 5.13-11.43 11.43S8.27 26 14.57 26 26 20.87 26 14.57 20.87 3.14 14.57 3.14"
      }), /*#__PURE__*/_jsx("path", {
        d: "M14.57 15.75c-2.85 0-5.16-2.32-5.16-5.16s2.32-5.16 5.16-5.16 5.16 2.32 5.16 5.16-2.32 5.16-5.16 5.16m0-8.04a2.88 2.88 0 1 0 .001 5.761 2.88 2.88 0 0 0-.001-5.761M10 22.03c-.32 0-.64-.14-.87-.4-.41-.48-.35-1.2.13-1.61a8.2 8.2 0 0 1 5.31-1.96 1.14 1.14 0 1 1 0 2.28c-1.4 0-2.76.5-3.83 1.41-.22.18-.48.27-.74.27Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M19.14 22.03c-.26 0-.53-.09-.74-.27a5.9 5.9 0 0 0-3.83-1.41 1.14 1.14 0 1 1 0-2.28c1.95 0 3.83.69 5.31 1.96.48.41.54 1.13.13 1.61-.23.26-.55.4-.87.4Z"
      })]
    })
  }));
};
AudienceTargetingIcon.displayName = 'AudienceTargetingIcon';